import type {AcceptableRootValueEditorLocalizations, AcceptableRootValueEditorOptions} from './types';
import type {DefaultOptions} from '../../../types';
import DefaultOptionLabel from '../_shared/DefaultOptionLabel.svelte';
import type {SvelteComponentConstructor} from 'core/types';


export const ACCEPTABLE_ROOT_VALUE_EDITOR_DEFAULT_OPTIONS: DefaultOptions<AcceptableRootValueEditorOptions<null>> = {
    acceptableValue: null,
    disabledItems: [],
    optionLabelComponent: DefaultOptionLabel as SvelteComponentConstructor<{option}>,
    optionIdResolver: ({option}) => option,
};

/**
 * @ngdoc constant
 * @name ACCEPTABLE_ROOT_VALUE_EDITOR_DEFAULT_LOCALIZATIONS
 * @module portaro.value-editors.acceptable-root
 *
 * @description
 * ```
 * {
 *      cannotSelect: '(cannot select)',
 *      expandNode: 'Expand',
 *      collapseNode: 'Collapse',
 *      description: '',
 * }
 * ```
 */
export const ACCEPTABLE_ROOT_VALUE_EDITOR_DEFAULT_LOCALIZATIONS = Object.freeze<AcceptableRootValueEditorLocalizations>({
    cannotSelect: '(cannot select)',
    expandNode: 'Expand',
    collapseNode: 'Collapse',
    description: '',
});